import { render, staticRenderFns } from "./RequestAccountDeletion.vue?vue&type=template&id=887e21fa&scoped=true&lang=html&"
import script from "./RequestAccountDeletion.vue?vue&type=script&lang=js&"
export * from "./RequestAccountDeletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887e21fa",
  null
  
)

export default component.exports